import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cart-quantity d-flex a-i-center j-content-center"
}
const _hoisted_2 = ["disabled", "min", "max", "placeholder"]
const _hoisted_3 = ["disabled", "min", "max", "placeholder"]
const _hoisted_4 = { class: "text-raleway-20" }

import ErrorMessageComponent from "../errorMessage/errorMessageView.vue";
import ErrorGlobalComponent from "../errorGlobal/errorGlobalView.vue";
import { CARS, TRUCK } from "@/store/modules/Search/type";
import { closestNumber } from "@/utils/cart/closesNumber";
import { toRefs, ref, computed } from "vue";
import { IStore } from "@/store/types/StoreType";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectNumberCart',
  props: {
    placeholder: {},
    step: {},
    min: {},
    max: {},
    value: {},
    button: { type: Boolean },
    percent: { type: Boolean },
    stock: {},
    notDelete: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const store = useStore<IStore>();
const data = toRefs(props);

const userGroup = ref(computed<string[]>(() => store.getters.accessGroupGet));

const lastValue = ref(
  computed(() =>
    isNaN(+data.placeholder.value) ? "0" : data.placeholder.value
  )
);
const count = ref<string>(
  isNaN(+data.placeholder.value) ? "0" : data.placeholder.value
);
const error = ref(false);

const checkUserGroup = () =>
  userGroup.value.some((value) => value === "inactive");
const disabled = ref(checkUserGroup());
const addCarToCartButtonDec = () => {
  if (loading.value || data.max.value === 0) return;
  if (disabled.value) return (error.value = true);
  if (Number(count.value) - data.step.value < 0) {
    count.value = "0";
    return deletePositionValue();
  }
  count.value = (Number(count.value) - data.step.value).toString();
  checkValue();
};

const addCarToCartButtonEnc = () => {
  if (loading.value || data.max.value === 0) return;
  if (disabled.value) return (error.value = true);
  if (Number(count.value) + data.step.value > data.max.value) {
    count.value = data.max.value.toString();
    return setMaxPositionValue();
  }
  count.value = (Number(count.value) + data.step.value).toString();
  checkValue();
};

const addCarToCart = (event: Event) => {
  if (data.max.value === 0) return;
  if (disabled.value) return (error.value = true);
  if (data.notDelete?.value || !event) return;

  const target = event?.currentTarget as HTMLInputElement;

  if (!target) return;
  let value = Number(target?.value);

  if (!value || isNaN(value)) return;

  if (value < 0) value = 0;

  count.value = value.toString();
};

const changeError = () => (error.value = !error.value);
const token = ref(computed<string>(() => store.getters.accessTokenGet));
const loading = ref(computed<boolean>(() => store.getters.getLoadingCart));
const serverType = ref(computed<string>(() => store.getters.getServerType));

const checkValue = () => {
  if (data.max.value === 0) return (count.value = '0');
  if (Number(count.value) <= data.max.value && Number(count.value) > 0) {
    return !token.value && serverType.value === "retail"
      ? store.commit("addOrDeleteCartLocal", {
          cars: data.value.value,
          amount: Number(count.value),
          stock: data.stock.value,
        })
      : store.commit("addOrDeleteCart", {
          cars: data.value.value,
          amount: Number(count.value),
          stock: data.stock.value,
        });
  }
  if (Number(count.value) > data.max.value) {
    count.value = data.max.value.toString();
    return setMaxPositionValue();
  }
  if (disabled.value) return (error.value = true);
  count.value = closestNumber(Number(count.value), data.step.value).toString();
  if (Number(count.value) > data.max.value)
    return (count.value = closestNumber(
      Number(data.max.value),
      data.step.value
    ).toString());
  if (lastValue.value === count.value) return;
  return !token.value && serverType.value === "retail"
    ? store.commit("addOrDeleteCartLocal", {
        cars: data.value.value,
        amount: Number(count.value),
        stock: data.stock.value,
      })
    : store.commit("addOrDeleteCart", {
        cars: data.value.value,
        amount: Number(count.value),
        stock: data.stock.value,
      });
};
const setMaxPositionValue = () => {
  if (data.max.value === 0) return;
  if (disabled.value) return (error.value = true);
  if (lastValue.value === count.value) return;
  return !token.value && serverType.value === "retail"
    ? store.commit("addOrDeleteCartLocal", {
        cars: data.value.value,
        amount: Number(count.value),
        stock: data.stock.value,
      })
    : store.commit("addOrDeleteCart", {
        cars: data.value.value,
        amount: Number(count.value),
        stock: data.stock.value,
      });
};
const deletePositionValue = () => {
  if (loading.value || data.max.value === 0) return;
  if (disabled.value) return (error.value = true);
  if (lastValue.value === count.value) return;
  return !token.value && serverType.value === "retail"
    ? store.commit("addOrDeleteCartLocal", {
        cars: data.value.value,
        amount: Number(count.value),
        stock: data.stock.value,
      })
    : store.commit("addOrDeleteCart", {
        cars: data.value.value,
        amount: Number(count.value),
        stock: data.stock.value,
      });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(data).button?.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-100 d-flex j-content-center a-i-center pointer input-quantity-cart-button transition-015 left", { 'disabled-button': disabled.value, 'loading-button': loading.value }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addCarToCartButtonDec()))
          }, " - ", 2),
          _withDirectives(_createElementVNode("input", {
            disabled: disabled.value,
            type: "number",
            min: _unref(data).min.value,
            max: _unref(data).max.value,
            class: "text-raleway-13 input search-sm-input input-quantity-cart",
            placeholder: _unref(data).placeholder.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((count).value = $event)),
            onInput: addCarToCart,
            onFocusout: checkValue
          }, null, 40, _hoisted_2), [
            [
              _vModelText,
              count.value,
              void 0,
              { number: true }
            ]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["w-100 d-flex j-content-center a-i-center pointer input-quantity-cart-button transition-015 right", { 'disabled-button': disabled.value, 'loading-button': loading.value }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (addCarToCartButtonEnc()))
          }, " + ", 2)
        ]))
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          disabled: disabled.value,
          type: "number",
          min: _unref(data).min.value,
          max: _unref(data).max.value,
          class: "text-raleway-13 input search-sm-input input-quantity",
          placeholder: _unref(data).placeholder.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((count).value = $event))
        }, null, 8, _hoisted_3)), [
          [
            _vModelText,
            count.value,
            void 0,
            { number: true }
          ]
        ]),
    (error.value)
      ? (_openBlock(), _createBlock(ErrorGlobalComponent, {
          key: 2,
          error: error.value,
          changeError: changeError
        }, {
          default: _withCtx(() => [
            _createVNode(ErrorMessageComponent, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$tc("Your account is not activated")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["error"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})